import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import AvgButton from '../ComControl/AvgButton'
import Viewport from '../ComControl/Viewport'
import { FileReader, FileWriter } from '@/platform'

class GameReplay {
    /**
     * 回放的背景图
     */
    public BackPic: FileName = new FileName()

    /**
     * 显示的限制区域
     */
    public Viewport: Viewport = new Viewport()

    /**
     * project_bin_no
     */
    public Close: AvgButton = new AvgButton()

    /**
     * 关闭按钮索引
     */
    public CloseEx: AvgButtonIndex = new AvgButtonIndex()

    /**
     * project_bin_no
     */
    public ButtonIndex: number = 0

    constructor(b?: AvgButton) {
        if (b !== undefined) {
            this.BackPic = new FileName({ type: FileName.DEF_TYPE, name: 'palyback.png' })
            this.Viewport = new Viewport(30, 50, 720, 520)
            this.ButtonIndex = 15
            this.Close = b
            this.CloseEx = new AvgButtonIndex(15, b.X, b.Y)
        } else {
        }
    }

    /** 与 cg_v3_data GameReplay @DataStrucrParse：BackPic → Viewport → Close → CloseEx → ButtonIndex */
    readBin(reader: FileReader): void {
        this.BackPic = new FileName(reader)
        this.Viewport = new Viewport()
        this.Viewport.readBin(reader)
        this.Close = new AvgButton()
        this.Close.readBin(reader)
        this.CloseEx = new AvgButtonIndex()
        this.CloseEx.readBin(reader)
        this.ButtonIndex = reader.readInt()
    }

    writeBin(writer: FileWriter): void {
        this.BackPic.writeBin(writer)
        this.Viewport.writeBin(writer)
        this.Close.writeBin(writer)
        this.CloseEx.writeBin(writer)
        writer.writeInt(this.ButtonIndex)
    }

    readVersionedOui(reader: FileReader): void {
        this.BackPic = new FileName(reader)
        this.CloseEx.readVersionedOui(reader.readObj(reader.readInt()))
        this.Viewport.readVersionedOui(reader.readObj(reader.readInt()))
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        this.BackPic.writeVersionedOui(writer)
        this.CloseEx.writeVersionedOui(writer)
        this.Viewport.writeVersionedOui(writer)

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}
export default GameReplay
